import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-treemap",
  "use": "icon-treemap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-treemap\"><path d=\"M64 128h512v448H64z m0 512h512v256H64z m576-192h320v448H640z m0-320h320v256H640z\" p-id=\"2381\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol